<script setup>
import { ArrowDown, ArrowDownBold, ArrowUp, ArrowUpBold } from '@element-plus/icons-vue';
import { watch, ref } from 'vue';

const props = defineProps(['dashboardData','date','preset']);
const stats = ref(0);
watch([() => props.dashboardData], () => {
    let pc = Number(props.dashboardData?.previousDateRangeDataCount);
    let te = Number(props.dashboardData?.totalEntries);
		if (pc <= 0) return;
    stats.value = Math.ceil(((te - pc) / pc) * 100);
})

</script>
<template>
    
    <div class="fv-stats">
      <div class="fv-count fv-stats-col">
        <span className="fv-text-xl">{{dashboardData?.totalEntries}}</span>
          <div v-if="preset !== 'Custom'">
            {{ preset.replaceAll('_', ' ') }}
          </div>
          <div v-else>
            {{ date[0] }} - 
            {{ date[1] }}
          </div>
      </div>
      <div v-if="Number(dashboardData?.previousDateRangeDataCount) === 0" class="fv-cmpr fv-stats-col">
        No Data to Compare!
      </div>
      <div v-else class="fv-cmpr fv-stats-col">
        <div v-if="dashboardData?.totalEntries >= Number(dashboardData?.previousDateRangeDataCount)" class="fv-cmpr-up">
          <el-icon><ArrowUpBold /></el-icon>
          <span>{{stats}}%</span>
        </div>
        <div v-else class="fv-cmpr-down">
          <el-icon><ArrowDownBold /></el-icon>
          <span>{{stats}}%</span>
        </div>
      </div>
    </div>
</template>